module.exports = __webpack_public_path__ + "media/images/dashboard-nav-2c2799ff89ec34d92b559ecfddd2c045.svg";